import React from "react";

const ErrorComponent = ({ message, retry }) => {
  return (
    <div className="bg-red_error bg-opacity-5 border-l-4 border-red_error rounded-md p-5 my-4 shadow-sm">
      <div className="flex">
        <div className="flex-shrink-0">
          {/* Error icon */}
          <svg className="h-6 w-6 text-red_error" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-base font-semibold text-red_error">Error Loading Content</h3>
          <div className="mt-1 text-sm text-gray-800">
            <p>{message || "Something went wrong. Please try again later."}</p>
          </div>
          {retry && (
            <div className="mt-3">
              <button
                type="button"
                onClick={retry}
                className="inline-flex items-center px-3 py-1.5 border border-red_error text-sm font-medium rounded-md text-red_error bg-white hover:bg-red-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-400"
              >
                <svg className="mr-1.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                Try again
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
